module.exports = __webpack_public_path__ + "img/MONTES CLAROS - SINDINOR.8a9aa027.png";